import { render, staticRenderFns } from "./SubPickItem.vue?vue&type=template&id=10773174&scoped=true&"
import script from "./SubPickItem.vue?vue&type=script&lang=js&"
export * from "./SubPickItem.vue?vue&type=script&lang=js&"
import style0 from "./SubPickItem.vue?vue&type=style&index=0&id=10773174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10773174",
  null
  
)

export default component.exports